// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"14e3baa0","498":"2cb2a175","703":"6e5bc743","787":"1c1547d5"}[chunkId] + ".chunk.js";
};